import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@navikt/aksel-icons';
import { DistributionChannel } from '../../../../api/queries';
import { getChannelDisplayValue } from '../channelDisplay';
import classes from './DistributionChannelListItem.module.css';

type DistributionChannelListItemProps = {
  channel: DistributionChannel;
  onRemove: (channel: DistributionChannel) => void;
};

export const DistributionChannelListItem = ({
  channel,
  onRemove,
}: DistributionChannelListItemProps) => {
  const { t } = useTranslation();
  const value = getChannelDisplayValue(channel);

  return (
    <li className={classes.row}>
      <span aria-hidden="true" className={classes.avatar}>
        {channel.type.charAt(0).toUpperCase()}
      </span>
      <span className={classes.details}>
        <span className="ds-label" data-size="sm">
          {channel.type}
        </span>
        <span className={`ds-paragraph ${classes.value}`} data-size="sm">
          {value}
        </span>
      </span>
      <button
        type="button"
        className="ds-button"
        data-variant="tertiary"
        data-color="danger"
        data-size="sm"
        aria-label={t('surveyCreation.distributionChannels.removeLabel', {
          type: channel.type,
          value,
        })}
        onClick={() => onRemove(channel)}
      >
        <TrashIcon aria-hidden="true" fontSize="1.125rem" />
        {t('surveyCreation.distributionChannels.remove')}
      </button>
    </li>
  );
};
